const data = (collection, keyword) => (
  collection
    && Object.values(collection).filter((item) => {
      const topic = item.attributes.topic.toLowerCase();
      const host = item.attributes.host.toLowerCase();

      let available = false;
      if (topic.includes(keyword.toLowerCase())
          || host.includes(keyword.toLowerCase())) {
        available = true;
      }

      return available;
    })
);

export default data;
